// src/components/select/ReportFolderSelector.tsx

import { AccountBalanceTwoTone } from '@mui/icons-material'
import {
  Avatar,
  ListItemText,
  MenuItem,
  Select,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material'

import { FolderId, FolderPool } from '@/types/domain/folder'
import { SensorPool } from '@/types/domain/sensor'

import { HStack } from '..'
import { categoryByType } from '../../api'
import { useFolderPool, useSensorPool } from '../../hooks'

const FLATTEN = f => f.attributes
const FILTER_CONSUMPTION = f =>
  f.sensor_target === 'consumption' ||
  f.sensor_target === 'performance' ||
  categoryByType(f.sensor_type, f.type_in_folder) === 'consumption' ||
  categoryByType(f.sensor_type, f.type_in_folder) === 'performance'

type Props = {
  id: FolderId
  onChange: (id: FolderId) => void
}

export const ReportFolderSelector = ({
  id,
  onChange: onChangeFolder,
}: Props) => {
  const theme = useTheme()
  const bgcolor = theme.palette.primary.main

  const fPool: FolderPool = useFolderPool()
  const sPool: SensorPool = useSensorPool()

  const onChange = event => onChangeFolder(event.target.value)

  return (
    <Select fullWidth onChange={onChange} value={id}>
      <MenuItem value={0}>
        <HStack alignItems={'center'}>
          <Tooltip title={'ID:0'}>
            <Avatar sx={{ bgcolor, mr: 2 }}>
              <AccountBalanceTwoTone />
            </Avatar>
          </Tooltip>

          <Typography>Gebäude wählen ...</Typography>
        </HStack>
      </MenuItem>

      {fPool.map(f => {
        const { image_url, name } = f.attributes

        const fsData = sPool
          .map(FLATTEN)
          .filter(i => Number(i.folder_id) === Number(f.id))
          .filter(FILTER_CONSUMPTION)
        const NO_CONSUMPTION_SENSORS = fsData.length === 0
        const secondary = `${fsData.length} Verbrauchssensoren`

        return (
          <MenuItem disabled={NO_CONSUMPTION_SENSORS} key={name} value={f.id}>
            <HStack alignItems={'center'}>
              <Tooltip title={`ID:${f.id}`}>
                <Avatar src={image_url} sx={{ mr: 2 }} />
              </Tooltip>

              <ListItemText primary={name} secondary={secondary} />
            </HStack>
          </MenuItem>
        )
      })}
    </Select>
  )
}
